export default "__VITE_ASSET__b568ab64__"